import { h } from 'preact';

import pageStyles from '../../../pageStyles';

import { SideBar } from '../../../../pieces/sidebar';
import { TopBar } from '../../../../pieces/topbar';
import { Header, Footer } from '../../../shared/desktop';
import { getCommonProps } from '../../../../../lib/page';

import { Column, Row, Section, ContainerFluid } from '@cube/layout';
import { PressWidget } from '@cube/finance-components';

export const Desktop = ({ pageConfig, ...props }) =>
	(
		<ContainerFluid class={pageStyles.fluidPageNoPadding}>
			<Header
				pageConfig={pageConfig}
				adId="sc_finance_header_banner"
				{...props}
			/>
			<TopBar
				type="finance"
			/>
			<Section rowClass={pageStyles.desktopContentPadding} containerClass={pageStyles.defaultPageWidth}>
				<Row>
					<Column>
						<PressWidget />
					</Column>
					<SideBar
						adPrefix="sc_finance"
						type="finance"
					/>
				</Row>
			</Section>
			<Footer
				pageConfig={pageConfig}
				{...getCommonProps(props)}
			/>
		</ContainerFluid>
	);
